export default "__VITE_ASSET__7f98a871__"